import {
    useGuideMessageProducingActionListener,
    type GuideMessageProducingActionPayload,
} from "@khan/events-guide";

import {useOpenThenSendChatMessageWhenInitialized} from "../event-handler/use-open-then-send-chat-message-when-initialized.ts";
import {useGuideAudioController} from "../hooks/use-guide-audio-controller.ts";

/**
 * A hook that listens for and handles Khanmigo events that produce messages
 * to be sent in a conversation.
 */
export const useGuideMessageEventHandling = () => {
    const sendChatMessage = useOpenThenSendChatMessageWhenInitialized();
    const {isVoiceOn, selectedVoice} = useGuideAudioController();

    useGuideMessageProducingActionListener(
        (event: GuideMessageProducingActionPayload) => {
            sendChatMessage(event.text, {
                containsSpeechToTextContent: false,
                guideVoiceDescriptor: isVoiceOn ? selectedVoice : null,
                prepopulatedText: event.text,
                requestUIType: event.requestUIType,
                requestWithTextToSpeech: isVoiceOn,
                timeToSubmit: 0,
            });
        },
    );
};
